import { Pagination } from '@mui/material'
import { CaretLeftIcon, Cross2Icon } from '@radix-ui/react-icons'
import { MoreHorizontal } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { useParams } from 'react-router-dom'
import { checkTagValidity } from '../../Utils/Utils'
import { ADD_BRIN, DELETE_BRIN } from '../../Utils/constant'
import { Port } from '../../components/Icons/Port'
import { UpdatePort } from '../../components/Pbo/UpdatePort'
import { Loader } from '../../components/Widget/Loader'
import { SubmitButton } from '../../components/Widget/SubmitButton'
import { deleteOne, store } from '../../services/service'
import { usePBOStore } from '../../store/pboStore/listPboStore'
import { usePortStore } from '../../store/pboStore/listPort'

export const PboPort = () => {
    const { id, nom } = useParams()
    const listPorts = usePortStore()
    const coupleurByPBO = usePBOStore()
    const [selectItem, setSelectItem] = useState(null)
    const {
        register,
        handleSubmit, reset,
        formState: { errors },
    } = useForm()
    const [isSubmit, setIsSubmit] = useState(false);
    const [error, setError] = useState("")

    const submit = (data) => {
        setIsSubmit(true)
        store(ADD_BRIN, 'application/json', data).then((res) => {
            if (res.status === 200) {
                listPorts.getData(`/${id}?page=0&size=30&status=`)
                document.getElementById('close').click()
                toast.success('Enregistrement effectuté')
                setIsSubmit(false)
                reset()
            }
        }).catch((err) => {
            setIsSubmit(false)
            setError(err?.response?.data?.donnee)
        })
    }

    useEffect(() => {
        coupleurByPBO.getCoupleurByPBO(id)
        listPorts.getData(`/${id}?page=0&size=30&status=`)
    }, [])

    const more = (page) => {
        listPorts.getData(`/${id}?page=${page - 1}&size=30&status=`)
    }

    return (
        <div className="">
            <div className="lg:flex gap-8 items-center">
                <button className='btn bg-white btn-sm' onClick={() => { window.history.back() }}><CaretLeftIcon /></button>
                <h3 class="font-mtn text-3xl font-bold">
                    Les brins de {decodeURIComponent(nom)}
                </h3>

            </div>
            <div className="rounded-md px-2 py-4 mt-3">
                <div className="mt-3 lg:flex items-center gap-2">
                    {/* <input
                        onChange={(e) => {
                            listPorts.getData(`/${id}?page=0&param=${e.target.value}&size=8&status=`)
                        }}
                        type="text" placeholder="Rechercher element..." className="text-xs input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
                    /> */}
                    <select onChange={(e) => {
                        listPorts.getData(`/${id}?page=0&size=30&status=${e.target.value}`)
                    }} className="select" >
                        <option disabled>
                            Status Pbos
                        </option>
                        <option value='LIBRE' selected>Libre</option>
                        <option value='RESERVER' >Reserver</option>
                        <option value='CONNECTER'>Connecter</option>
                        <option value='DEFECTUEUX' >Defectueux</option>
                    </select>
                    <div className='ml-auto flex items-center gap-2'>
                        <dialog id="add_pbo" className="modal rounded-none">
                            <div className="modal-box w-10/12 max-w-xl">
                                <div className="modal-action">
                                    <h1 className='font-mtn mr-auto text-2xl font-bold'>
                                        Ajouter un Brin
                                    </h1>
                                    <form method="dialog">
                                        <button id='close' className="btn btn-sm"><Cross2Icon /></button>
                                    </form>
                                </div>
                                <div>
                                    <p className='text-sm text-red-600'>{error}</p>
                                    <form onSubmit={handleSubmit(submit)} className="w-full  mx-auto mt-6">
                                        <div className="items-center gap-x-3">
                                            <label className="form-control">
                                                <div className="label -mb-1">
                                                    <span className="label-text font-medium">
                                                        Designation du brin <span className="text-red-500">*</span>
                                                    </span>
                                                </div>
                                                <input
                                                    {...register('designation', { required: true })}
                                                    type="text"
                                                    placeholder="designation du brin"
                                                    className="input input-bordered w-full h-10 text-sm "
                                                />
                                            </label>
                                        </div>
                                        {/* <label className="form-control w-full">
                                            <div className="label -mb-1">
                                                <span className="label-text font-medium">
                                                    Numero du brin <span className="text-red-500">*</span>
                                                </span>
                                            </div>
                                            <input
                                                {...register('numero', { required: true })}
                                                type="number"
                                                min={0}
                                                defaultValue={""}
                                                placeholder="Nombre de coupleur"
                                                className="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none app input input-bordered w-full h-10 text-sm "
                                            />
                                        </label> */}
                                        <div className='mt-3'>
                                            <label htmlFor="" className=' text-sm font-medium'>Coupleur <span className="text-red-500">*</span></label>
                                            <select {...register('coupleurId', { required: true })} className="select w-full " >
                                                <option value={''} selected disabled>
                                                    Coupleur
                                                </option>
                                                {
                                                    coupleurByPBO?.coupleurs?.map((item) => (
                                                        <option value={item.id} >Coupleur-{item.numero}</option>
                                                    ))
                                                }
                                            </select>
                                        </div>
                                        <SubmitButton isSubmit={isSubmit} label={"Enregistrer"} />
                                    </form>
                                </div>
                            </div>
                        </dialog>

                        {
                            checkTagValidity("AJOUTER_PORT") ?
                                <button
                                    onClick={() => {
                                        document.getElementById('add_pbo').showModal()
                                    }}
                                    className="btn btn-sm h-10 hover:bg-[#ffcb05] bg-[#ffcb05] "
                                >
                                    Ajouter un brin
                                </button> : null
                        }

                    </div>
                </div>
                {
                    checkTagValidity('LISTE_PORT') ?
                        <div className='grid md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-5 gap-2 my-8'>
                            {
                                listPorts?.data?.data?.length === 0 ? 'Aucune donnée' :
                                    listPorts?.data?.data?.length !== 0 && !listPorts?.loading ? (
                                        listPorts?.data?.data?.map((item) => (
                                            <div key={item.id} className='relative flex gap-1 items-center cursor-pointer text-black shadow-sm border bg-white  rounded text-xs'>
                                                <div className="dropdown dropdown-end absolute right-2 top-2">
                                                    <div
                                                        tabIndex={0}
                                                        role="button"
                                                        className="w-4 h-4 rounded-full flex items-center bg-gray-50"
                                                    >
                                                        <MoreHorizontal size={20} />
                                                    </div>
                                                    <ul
                                                        tabIndex={0}
                                                        className="mt-1 dropdown-content z-[1] menu p-2 border shadow bg-base-100 rounded-lg w-44"
                                                    >
                                                        {/* {
                                                            checkTagValidity('MODIFIER_STATUT_PORT') ?
                                                                <></>
                                                                : null
                                                        } */}
                                                        {
                                                            item?.abonnement !== null ? <button
                                                                onClick={() => {
                                                                    document.getElementById('intention').showModal()
                                                                    setSelectItem(item)
                                                                }
                                                                }
                                                                className="bg-white text-black hover:bg-gray-300 font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                                                            >
                                                                Details sur le brin
                                                            </button>
                                                                :
                                                                null
                                                        }



                                                        {
                                                            checkTagValidity('MODIFIER_STATUT_PORT') ?
                                                                <button
                                                                    onClick={() => {
                                                                        setSelectItem(item)
                                                                        document.getElementById(`edit${item.id}`).showModal()
                                                                    }
                                                                    }
                                                                    className="bg-white text-black hover:bg-gray-300 font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                                                                >
                                                                    Modifier
                                                                </button>
                                                                : null
                                                        }
                                                        <dialog id='intention' className="modal rounded-none">
                                                            <div className="modal-box w-10/12 max-w-xl">
                                                                <div className="modal-action">
                                                                    <h1 className='font-mtn mr-auto text-2xl font-bold'>
                                                                        Details du Brin
                                                                    </h1>
                                                                    <form method="dialog">
                                                                        <button id='close_edit' className="btn btn-sm"><Cross2Icon /></button>
                                                                    </form>
                                                                </div>
                                                                <div>
                                                                    <div className="bg-white p-3 rounded-lg">
                                                                        <div className="">
                                                                            <dl className="divide-y divide-gray-100">
                                                                                <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                                    <dt className="text-sm font-semibold text-gray-900">
                                                                                        Numero ticket
                                                                                    </dt>
                                                                                    <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                                                                        {selectItem?.abonnement?.eligibilite?.numeroTicket}
                                                                                    </dd>
                                                                                </div>

                                                                                <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                                    <dt className="text-sm font-semibold leading-6 text-gray-900">
                                                                                        Client
                                                                                    </dt>
                                                                                    <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                                                                        {selectItem?.abonnement?.client?.nomPrenoms}
                                                                                    </dd>
                                                                                </div>
                                                                                <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                                    <dt className="text-sm font-semibold leading-6 text-gray-900">
                                                                                        Commune et quartier
                                                                                    </dt>
                                                                                    <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                                                                        {selectItem?.abonnement?.domicile?.quartier?.commune?.designation}, {" "}
                                                                                        {selectItem?.abonnement?.domicile?.quartier?.designation}

                                                                                    </dd>
                                                                                </div>
                                                                                <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                                    <dt className="text-sm font-semibold leading-6 text-gray-900">
                                                                                        Type de maison
                                                                                    </dt>
                                                                                    <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                                                                        {selectItem?.abonnement?.batiment?.designation}

                                                                                    </dd>
                                                                                </div>


                                                                                <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                                    <dt className="text-sm font-semibold leading-6 text-gray-900">
                                                                                        Numero FTTH
                                                                                    </dt>
                                                                                    <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                                                                        {selectItem?.abonnement?.numeroFtth}
                                                                                    </dd>
                                                                                </div>

                                                                                <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                                    <dt className="text-sm font-semibold leading-6 text-gray-900">
                                                                                        Etape
                                                                                    </dt>
                                                                                    <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                                                                        {selectItem?.abonnement?.status.toLowerCase().replace(/_/g, " ")}
                                                                                    </dd>
                                                                                </div>
                                                                            </dl>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </dialog>

                                                        <dialog id={`edit${item.id}`} className="modal rounded-none">
                                                            <div className="modal-box w-10/12 max-w-xl">
                                                                <div className="modal-action">
                                                                    <h1 className='font-mtn mr-auto text-2xl font-bold'>
                                                                        Modifier le brin
                                                                    </h1>
                                                                    <form method="dialog">
                                                                        <button id='close_edit' className="btn btn-sm"><Cross2Icon /></button>
                                                                    </form>
                                                                </div>
                                                                <div>
                                                                    <p className='text-sm text-red-600'>{error}</p>
                                                                    <UpdatePort portId={item?.id} defaultValue={item?.status} designation={item?.designation} />
                                                                </div>
                                                            </div>
                                                        </dialog>

                                                        {
                                                            checkTagValidity('SUPPRIMER_PORT') ?
                                                                <button
                                                                    onClick={() => {
                                                                        setSelectItem(item)
                                                                        document.getElementById('delete').showModal()
                                                                    }
                                                                    }
                                                                    className="bg-white hover:bg-red-600 text-black hover:text-white font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                                                                >
                                                                    Supprimer
                                                                </button>
                                                                : null
                                                        }
                                                        <dialog id="delete" className="modal">
                                                            <div className="modal-box max-w-md rounded-lg">
                                                                <h3 className="font-extrabold text-xl text-red-600 ">
                                                                    Attention
                                                                </h3>
                                                                <p className="pt-2 text-black font-medium">
                                                                    Voulez vous vraiment effectuer cette action ?
                                                                </p>
                                                                <div className="modal-action">
                                                                    <form
                                                                        method="dialog"
                                                                        className="w-full flex items-center justify-end gap-x-4"
                                                                    >
                                                                        <button className="bg-gray-100 text-gray-600 w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                                                                            Annuler
                                                                        </button>
                                                                        <button onClick={() => {
                                                                            deleteOne(DELETE_BRIN, selectItem.id).then(() => {
                                                                                toast.success('Element suprimé')
                                                                                listPorts.getData(`/${id}?page=0&size=8&status=`)
                                                                            }).catch((err) => {

                                                                            })
                                                                        }} className="bg-red-600 text-white w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                                                                            Supprimer
                                                                        </button>
                                                                    </form>
                                                                </div>
                                                            </div>
                                                        </dialog>
                                                    </ul>
                                                </div>
                                                <div className='bg-amber-400 w-10 h-10 rounded m-1 flex items-center justify-center'>
                                                    <Port />
                                                </div>
                                                <div className=''>
                                                    <p className='font-bold truncate w-36'>{item.designation}</p>
                                                    <p className={`w-fit px-1 border rounded-full ${item?.status === 'LIBRE' ? 'text-yellow-600' : item?.status === 'RESERVER' ? 'text-blue-700' : item?.status === 'CONNECTER' ? 'text-green-500' : 'text-red-600'}`}>{item?.status.toLowerCase()}</p>
                                                </div>
                                            </div>
                                        ))
                                    ) : <Loader />
                            }

                        </div>
                        : null
                }


            </div >
            {
                listPorts?.data?.length === 0 && !listPorts.loading ? null :
                    <div className='my-3 flex justify-end'>
                        <Pagination onChange={(event, newValue) => more(newValue)}
                            onSelect={selectedPage => more(selectedPage)} count={listPorts?.data?.totalPages} variant="outlined" color='primary' shape="rounded" />
                    </div>
            }

        </div >
    )
}
